<template>
  <div class="django-page ml-2">
    <h2>Variables Tracing</h2>
    <pc-pytrace-promo override-title="Variable tracing is more fun with PyTrace"></pc-pytrace-promo>
    <div class="mt-4">
      <p>PyCrunch can be used to trace variables at any point of execution:</p>
      <img src="../../assets/features/python_variable_tracing.png"
           class="img-fluid trace-one">
      <p class="mt-4">To start tracing, import following function</p>
      <code style="white-space: pre-wrap">from pycrunch.insights import trace</code>
      <p class="mt-4">And use it in your test or application code:</p>
      <code style="white-space: pre-wrap">def test_trace_dict_variable():
        a = 2
        b = 3
        x = a + b
        trace(some_dictionary=dict(a=a, b=b, sum=x))
        trace(can_trace_a_lot=True)

        # or, new in pycrunch-engine==1.1
        positional_argument_only = True
        trace(positional_argument_only)
      </code>
      <p>Trace function accepts arbitrary number of positional and keyword arguments. For example:</p>
      <p><code>trace(1, var_b=2, var_c=True)</code></p>
      <p>It is also possible to open traced variables in new Timeline tab.
        Values opened this way are immutable unless you close corresponding tab. </p>
      <p>This will allow to compare values across multiple runs. You can even save them to scratch files if you need to do so.</p>
      <img src="../../assets/features/variable_in_new_tab.png"
           class="img-fluid trace-one">
      <p class="mt-4">Note: this is supported in version > 0.9, for existing users you will need to upgrade your engine and PyCharm extension </p>
      <p><code>pip install --upgrade pycrunch-engine</code></p>
    </div>
  </div>
</template>

<script>
  import PcPytracePromo from '../PcPytracePromo'
  export default {
    name: 'django-support.page',
    components: { PcPytracePromo },
  }
</script>

<style scoped>
  .trace-one {
    width: 900px;
  }
</style>